import React from 'react';
import { motion } from 'framer-motion';
import './Workwithus.css';
const Workwithus = () => {
  return (
    <div className='work-with-us-container'>
      <div>
        <motion.button
          style={{
            top: '1rem',
            width: 'fit-content',
            padding: '0.9rem',
            backgroundColor: 'transparent',
            color: 'white',
            // textAlign: 'center',
            border: 'none',
            boxShadow: '0 0 1px white',
            borderRadius: '0.7rem',
            cursor: 'pointer',
            fontFamily: 'var(--framer-font-family)', // Apply font settings
            fontWeight: 'var(--framer-font-weight)',
            letterSpacing: 'var(--framer-letter-spacing)',
            textAlign: 'center', // Center the button text
          }}
          whileHover={{
            boxShadow:
              '0 0 5px black, 0 0 10px black, 0 0 15px white, 0 0 20px black', // Glow effect with white in between
            transition: { duration: 0.5 }, // Slow-motion effect
          }}
          whileTap={{
            scale: 0.9, // Shrink the button slightly on tap
            transition: { duration: 0.2 }, // Quick tap effect
          }}
        >
          Comparison
        </motion.button>
      </div>
      <div>
        <h1
          className='framer-text'
          style={{
            textAlign: 'center',
            color: 'white',
            fontWeight: 'var(--framer-font-weight)',
          }}
        >
          But, why would you want to work with us?
        </h1>
      </div>
    </div>
  );
};

export default Workwithus;
